import withMediaQuery from './withMediaQuery';
export default withMediaQuery;